export default __webpack_public_path__ + "static/media/plus-rede.c49af3ae.svg";